import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const ChannelItem = {
    Button: styled.button `
    border: none;
    outline: none;
    width: inherit;
    position: relative;
    background-color: ${({ theme }) => theme.color.backgroundAside};
    padding-right: 0;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;

    &:focus {
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
  `,
    Item: styled.li `
    color: ${({ theme }) => theme.color.text};
    background-color: ${({ isSelected, theme, }) => (isSelected ? theme.color.background : theme.color.backgroundAside)};
    padding: 12px;
    margin-left: 1em;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    &:hover {
      background-color: ${({ theme }) => theme.color.backgroundHoverAside};
      cursor: pointer;
    }
    ${media.medium} {
      align-items: flex-start;
      font-size: 0.8rem;
    }
  `,
    ItemContainer: styled.div `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
  `,
    ItemHeader: styled.div `
    display: flex;
    width: 100%;
  `,
    ItemHeaderText: styled.h4 `
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
    Text: styled.p `
    font-size: 0.8em;
    color: ${({ theme }) => theme.color.textMuted};
    padding-left: 0.5em;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    text-align: start;
  `,
    UnreadMessageIcon: styled.p `
    position: absolute;
    top: 10px;
    right: 2em;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.color.backgroundBrand};
    color: ${({ theme }) => theme.color.background};
    min-width: 24px;
    min-height: 24px;
    width: 0;
    height: 0;
    display: grid;
    place-items: center;
    font-size: 10px;
  `,
    NumberOfMembersIcon: styled.p `
    position: absolute;
    top: 4.2em;
    left: 7em;
    border-radius: 25%;
    background-color: ${({ theme }) => theme.color.badge};
    width: 20px;
    height: 20px;
    display: grid;
    place-items: center;
    font-size: 8px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.headerTextColor};
  `,
};
export default ChannelItem;
//# sourceMappingURL=ChannelItem.styled.js.map